<template>
  <div v-if="!loading" class="pc-mode">
    <site-header/>
    <div class="back-primary-lighter border-bottom-primary">
      <div class="container">
        <h1>{{ todayDelays.created_at | jpfulltime }}更新</h1>
        <ul class="nav nav-tabs nav-fill nav-area">
          <li class="nav-item" v-bind:key="area.area_id" v-for="area in areas" :style="{ width: areaNavWidth + 'px' }">
            <router-link class="nav-link" v-bind:class="[area.area_id == areaId ? 'active' : [checkAreaHasDelay(area.area_id) === true ? 'delay' : 'no-delay']]" :to="{ name: 'SiteTopArea', params: { areaId: area.area_id }}">{{ area.display_name }}<br>エリア</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <article>
        <div class="site_info" v-if="siteInfo" v-html="siteInfo"></div>
        <div id="area_info_csv" class="site_info" v-if="areaInfoCSV" v-html="areaInfoCSV"></div>
        <div v-if="maintenanceCSV && checkMaintenance()" id="maintenance_csv" v-html="maintenanceCSV"></div>
        <table class="w-100">
          <thead id="thead">
            <tr>
              <th :style="{ width: '270px'}" class="text-center">路線</th>
              <th v-bind:class="{ active: timeZone.time_zone_id == activeTimeZone }" class="th-timezone text-center" v-bind:key="timeZone.time_zone_id" v-for="timeZone in timeZones" :style="{ width: timeZone.cellWidth}">{{ timeZone.display_name }}</th>
              <th :style="{ width: '90px'}" class="text-center">履歴</th>
            </tr>
          </thead>
          <tbody id="tbody" v-if="area">
            <!-- for fixed cell width -->
            <tr class="fixed-width">
              <th :style="{ width: '270px'}"></th>
              <th v-bind:key="timeZone.time_zone_id" v-for="timeZone in timeZones" :style="{ width: timeZone.cellWidth}"></th>
              <th :style="{ width: '90px'}"></th>
            </tr>
            <!-- for fixed cell width --- END -->
            <tr v-bind:key="line.line_id" v-for="line in area.lines">
              <td>
                <div>
                  <span class="line-mark">
                    <i :style="{ background: line.line_color_1, color: lineSignColor(line.line_sign_color_1) }">{{ line.line_sign_1 }}</i>
                    <i v-if="line.line_sign_2" :style="{ background: line.line_color_2, color: lineSignColor(line.line_sign_color_2) }">{{ line.line_sign_2 }}</i>
                    <i v-if="line.line_sign_3" :style="{ background: line.line_color_3, color: lineSignColor(line.line_sign_color_3) }">{{ line.line_sign_3 }}</i>
                  </span>
                  <div class="line-info">
                    <span class="line-name">{{ line.line_name }}</span>
                    <span v-if="line.section_name" class="section-name">{{ line.section_name }}</span>
                  </div>
                </div>
              </td>
              <td v-bind:class="{ active: lineTimeZoneDelay.time_zone_id == activeTimeZone }" class="text-center" v-bind:key="lineTimeZoneDelay.time_zone_id" v-for="lineTimeZoneDelay in getTodayLineDelays(area.area_id, line.line_id)">
                <router-link v-bind:class="{ is_modified: lineTimeZoneDelay.is_modified === true }" class="btn-delay" :to="{ name: 'TodayDelayCertificate', params: { today: 'today',areaId: area.area_id, lineId: line.line_id, timeZoneId: lineTimeZoneDelay.time_zone_id }}"  target="_blank" v-if="lineTimeZoneDelay.delay_certificate_item_type === 'DELAY_CERTIFICATE'" :style="{ width: lineTimeZoneDelay.cellWidth}">
                  <img src="../../assets/images/delay_icon.png"/><br/>
                  <span class="delay-time">{{ lineTimeZoneDelay.delay_certificate }}</span><br/>
                  <span class="str-modified" v-if="lineTimeZoneDelay.is_modified === true">変更</span>
                </router-link>
                <span class="string-delay" v-bind:class="[ lineTimeZoneDelay.delay_certificate === '調整中' ? 'maintenance' : '', lineTimeZoneDelay.delay_certificate !== 'ー' ? 'into_target_time' : 'out_of_target_time' ]" v-else-if=" lineTimeZoneDelay.delay_certificate_item_type === 'OTHERS'">
                  <span v-html="divideStringDelay(lineTimeZoneDelay.delay_certificate)"></span><br/>
                  <span class="str-modified" v-if="lineTimeZoneDelay.is_modified === true">変更</span>
                </span>
              </td>
              <td align="center">
                <router-link class="history" variant="primary btn-block" :to="{ name: 'History', params: { areaId: area.area_id, lineId: line.line_id }}">履歴<font-awesome-icon  :icon="['fas', 'caret-right']"></font-awesome-icon></router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="comment">
          ※ 遅延証明書の掲載状況を路線別に表示しています。<br>
          ※ 時分をクリックすると、遅延証明書画面を表示します。<br>
          ※ 履歴をクリックすると、過去45日間の履歴を表示します。
        </div>
      </article>
    </div>
    <site-footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/pc/SiteHeader'
import SiteFooter from '@/components/pc/SiteFooter'
import { mapState } from 'vuex'
var moment = require('moment')
export default {
  name: 'SiteTop',
  components: {
    SiteHeader,
    SiteFooter
  },
  data () {
    const now = moment()
    return {
      now,
      theadYPos: 0,
      scrollInit: true,
      areaNavWidth: 0
    }
  },
  methods: {
    isValidAreaId (num) {
      return num === undefined || /^\d+$/.test(num) === true
    },
    setAreaId () {
      if (this.$route.params.areaId > 0) {
        this.$store.dispatch('areaLine/setAreaId', this.$route.params.areaId)
      } else if (this.areas) {
        const keihansin = this.areas.find(area => area.display_name === '京阪神')
        if (keihansin === undefined) {
          this.$store.dispatch('areaLine/setAreaId', this.areas[0].area_id)
        } else {
          this.$store.dispatch('areaLine/setAreaId', keihansin.area_id)
        }
      }
    },
    getTodayLineDelays (areaId, lineId) {
      try {
        const lines = this.todayDelays.areas.filter((area) => area.area_id === areaId)[0].lines
        const l = lines.filter((line) => line.line_id === lineId)[0].delay_certificates
        return l
      } catch (err) {
        return []
      }
    },
    divideStringDelay (stringDelay) {
      if (stringDelay === '掲載はありません') {
        return '掲載は<br/>ありません'
      } else if (stringDelay === '掲載準備中') {
        return '掲載<br/>準備中'
      } else if (stringDelay === '調整中') {
        return '<br/>調整中'
      } else if (stringDelay === '掲載不可') {
        return '<br/>掲載不可'
      } else {
        return stringDelay
      }
    },
    checkAreaHasDelay (areaId) {
      try {
        return this.todayDelays.areas.find(area => area.area_id === areaId).have_delay_certificate
      } catch (err) {
        return []
      }
    },
    checkMaintenance () {
      if (this.todayDelays && this.todayDelays.areas) {
        const linesDelay = this.todayDelays.areas.find(area => area.area_id === this.areaId)
        if (linesDelay && linesDelay.lines) {
          for (var line of linesDelay.lines) {
            if (line && line.delay_certificates) {
              for (var timeZoneDelay of line.delay_certificates) {
                if (timeZoneDelay.delay_certificate === '調整中') {
                  return true
                }
              }
            }
          }
        }
      }
      return false
    },
    lineSignColor (data) {
      return data === '' ? '#000' : data
    },
    onScroll () {
      var thead = document.getElementById('thead')
      var tbody = document.getElementById('tbody')
      if (this.scrollInit) {
        this.theadYPos = thead.getBoundingClientRect().bottom
        this.scrollInit = false
      }
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition >= this.theadYPos) {
        thead.classList.add('position-fixed')
        tbody.style.paddingTop = '40px'
      } else {
        thead.classList.remove('position-fixed')
        tbody.style.paddingTop = '0'
      }
    },
    init () {
      if (this.areaStatus !== 'init' || this.timeZoneStatus !== 'init') {
        return
      }
      this.areaNavWidth = 1 / this.areas.length
      this.setAreaId()
      if (this.area === undefined) {
        this.$router.push({path: '/404'})
      } else {
        this.$store.dispatch('delaycertificatetoday/all', [this.areas, this.timeZones])
        this.$store.dispatch('externalData/siteInfo')
        this.$store.dispatch('externalData/areaInfoCSV', this.areaId)
        this.$store.dispatch('externalData/maintenanceCSV', this.areaId)
        this.checkLoaded()
      }
    },
    checkLoaded () {
      const timer = setInterval(() => {
        if (this.todayDelayStatus === 'init') {
          clearInterval(timer)
          this.$store.commit('loading/setStatus', false)
        }
      }, 100)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
    this.scrollInit = true
  },
  created () {
    if (!this.isValidAreaId(this.$route.params.areaId)) {
      this.$router.push({path: '/404'})
      return
    }
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    const unwatchAreaLine = this.$store.watch(
      (state) => state.areaLine.status,
      (value) => {
        if (value === 'init') {
          unwatchAreaLine()
          this.init()
        }
      }
    )
    const unwatchTimezone = this.$store.watch(
      (state) => state.timeZone.status,
      (value) => {
        if (value === 'init') {
          unwatchTimezone()
          this.init()
        }
      }
    )
  },
  watch: {
    $route (to, from) {
      this.setAreaId()
      this.$store.dispatch('externalData/areaInfoCSV', this.areaId)
      this.$store.dispatch('externalData/maintenanceCSV', this.areaId)
      this.$store.commit('loading/setStatus', false)
    }
  },
  computed: {
    ...mapState('externalData', {
      siteInfo: state => state.siteInfo,
      areaInfoCSV: state => state.areaInfoCSV,
      maintenanceCSV: state => state.maintenanceCSV
    }),
    ...mapState('areaLine', {
      areas: state => state.areas,
      areaId: state => state.areaId,
      area: state => state.area,
      areaStatus: state => state.status
    }),
    ...mapState('timeZone', {
      timeZones: state => state.timeZones,
      timeZoneStatus: state => state.status,
      activeTimeZone: state => state.activeTimeZone
    }),
    ...mapState('delaycertificatetoday', {
      todayDelays: state => state.todayDelays,
      todayDelayStatus: state => state.status
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.comment {
  margin-top: 20px;
}
footer {
  min-width: 970px;
}

.nav-tabs {
  .nav-item {
    .nav-link {
      font-weight: 600;
    }
  }
}
.back-primary-lighter {
  a {
    &.delay {
      background-color: $primary;
    }
    &.no-delay {
      background-color: #91b3d7;
    }
    &.nav-link {
      &.active {
        color: #0072ba !important;
        border-bottom-color: white !important;
      }
    }
  }
  min-width: 970px;
}

.site_info {
  background: white;
  padding: 25px;
  border: solid 1px #ccc;
  margin-top: 10px;
}
#maintenance_csv {
  margin-top: 10px;
  border: solid 1px #fa7d00;
  padding: 12px 25px;
  font-size: 14px;
  color: #fa7d00;
}
.site_info_title {
  font-weight: bold;
}
.container {
  h1 {
    font-weight: 600;
    font-size: 24px;
    padding: 20px 0 16px 0;
    color: #0072ba;
    margin-bottom: 0 !important;
  }
}
table {
  margin-top: 10px;
  border-collapse: separate;
  thead {
    &.position-fixed {
      position: fixed;
      background-color: white;
      width: 970px;
      margin-left: -2px;
      top: 0;
    }
    th {
      font-weight: normal;
      font-size: 14px;
      font-weight: 600;
      height: 40px;
      background-color: $table-th-normal;
      min-width: 90px;
      &.active {
        background-color: #e0f2ff;
      }
    }
  }
  tbody {
    tr {
      &.fixed-width {
        height: 0;
        td {
          height: 0;
        }
      }
      td {
        height: 72px;
        border-bottom: 1px solid #979797;
        vertical-align: middle !important;
        &.active {
          background-color: #e0f2ff;
        }
        .btn-delay {
          display: table-cell;
          background-color: #e0f2ff;
          border: solid 2px #abcbe8;
          border-radius: 0px;
          color: #3070b3;
          height: 63px;
          min-width: 80px;
          width: 100%;
          vertical-align: top;
          font-weight: 600;
          img {
            width: 10px;
            height: 10px;
          }
          .delay-time {
            font-size: 18px;
            line-height: 20px;
          }
          .str-modified {
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            color: #fa7d00;
          }
          &:hover {
            border: solid 2px $primary;
          }
        }
        &.no-info {
          font-size: 16px;
          color: #a7a7a7;
        }
        .string-delay {
          display: inline-block;
          margin-top: 5px;
          margin-bottom: 0;
          font-size: 14px;
          color:#a7a7a7;
          .str-modified {
            font-size: 12px;
            color: #fa7d00;
          }
          &.maintenance{
            min-height: 39px !important;
            color: #fa7d00;
          }
          &.into_target_time{
            min-height: 57px !important;
          }
        }
      }
      td > div {
        vertical-align: middle;
        display: flex;
        align-items: center;
        justify-content: center;
        .line-mark {
          display: inline-block;
          vertical-align: middle;
          margin-left: 5px;
          margin-right: 10px;
          font-size: 14px;
          font-weight: 600;
          width: 22px;
          i {
            border-radius: 3px;
            font-style: normal;
            display: block;
            width: 22px;
            height: 22px;
            padding: 2px;
            text-align: center;
            margin-bottom: 2px;
            color: white;
          }
        }
        .line-info {
          display: inline-block;
          flex: 1;
          span {
            display: block;
            &.line-name {
              font-size: 14px;
              font-weight: 600;
            }
            &.section-name {
              color: #a7a7a7;
              font-size: 12px;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
.history {
  display: block;
  background-color: white;
  color: black;
  border: solid 1px #cccccc;
  border-radius: 4px;
  line-height: 44px;
  text-align: center;
  width: 76px;
  font-weight: 600;
  svg {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/SiteTop.vue